[
  {
    "id": "anti_player_encounter_assassination",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_assassination_1",
        "text": "There are six men in the street and they are not looking at anybody else. At the end of the lane a grey-haired man in a travelling coat leans against the well with his arms folded, watching, in the manner of somebody who has arrived early for something scheduled."
      },
      {
        "id": "anti_player_encounter_assassination_2",
        "text": "\"You'll go left,\" he says, conversationally, to nobody. \"You always go left. Then you'll try the cooperage door, and it's barred on the inside on this particular morning, which you have no way of knowing yet.\" He straightens up. He does not draw. \"I'd tell you I'm sorry, but you won't remember me saying it as an apology. You'll remember it as information.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_ambush",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_ambush_1",
        "text": "The road looks exactly as it has looked every other time you have walked it, which is the first thing wrong with it. Then the ditch stands up."
      },
      {
        "id": "anti_player_encounter_ambush_2",
        "text": "\"This road,\" the grey man calls, from somewhere out of the line of sight, \"and the crossing before it, and the ford after. Three loops running. You are not a creature of habit, exactly — you are a creature of efficiency, and efficient people are the easiest of all to sit and wait for.\" A pause. \"Change your route. I mean that. It will cost me a season to relearn you and I would honestly rather earn it.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_training",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_training_1",
        "text": "They are not in the yard for you. They are between you and the swordmaster, which is a different thing, and it takes you a moment longer than it should to understand what that means."
      },
      {
        "id": "anti_player_encounter_training_2",
        "text": "\"You keep everything you learn,\" the grey man says from the gallery above, resting his forearms on the rail like a man watching a drill. \"I worked that out about you in the first year. So there is no point at all in killing you — you come back sharper. But the man who does the teaching is not like us. He is furniture. He resets, he stays dead for the season, and every season he spends dead is a season you spend not improving.\" He sounds tired rather than pleased. \"I don't enjoy this part.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_court",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_court_1",
        "text": "The antechamber is wrong before you can say why: no petitioners, no clerk at the desk, and the inner door standing very slightly open when it is never open at all."
      },
      {
        "id": "anti_player_encounter_court_2",
        "text": "\"The Chamberlain,\" the grey man says, without turning around, \"is the only man in this building who can put a stranger in front of the king. Not the guard captain, not the steward. Him. It took me eleven years to be certain of that.\" He finally looks at you, and there is something almost like apology in it. \"You cannot build a coalition without a door into it. I am closing the door. It is not personal and I would be lying if I said it was not effective.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_sabotage",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_sabotage_1",
        "text": "There is a table, and there are lamps, and there are perhaps forty letters on it in your handwriting. Some of them are addressed to courts you have not yet visited in this loop. One of them is a very warm note to the Necromancer's staff, thanking them."
      },
      {
        "id": "anti_player_encounter_sabotage_2",
        "text": "\"I have heard you make that argument four hundred times,\" the grey man says, setting down the pen. \"Your cadences, your appeals, the little self-deprecating turn you do before you ask for something. I could write you in my sleep and frequently have.\" He caps the ink. \"Steel was always going to fail. But a court that believes you sold them will not hear you again this year, and you do not have another year to spare. You have thirty-odd days. I checked.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_infiltration",
    "speaker": "A Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_encounter_infiltration_1",
        "text": "Your own colours. Your own drill. Your own soldiers, formed up properly and facing the wrong way, with the particular blank steadiness of men who are quite certain they are following orders."
      },
      {
        "id": "anti_player_encounter_infiltration_2",
        "text": "\"They are not traitors,\" the grey man says, and for the first time he sounds genuinely unhappy about something. \"They were given an order by a man in the right coat with the right seal who knew the right names, and they did what good soldiers do. If you kill them this morning that is on the order, not on them.\" He steps back into the line. \"I would like the record to show that I gave you the chance to know that first.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_duel",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_encounter_duel_1",
        "text": "No hirelings. No ditch. He is standing in the open with his coat folded over a milestone and his sword already drawn, and he has clearly been standing there some time."
      },
      {
        "id": "anti_player_encounter_duel_2",
        "text": "\"You've got good,\" he says, and means it. \"Genuinely. It took me nine years to reach where you are and I had nobody actively working against me for the first four of them.\" He rolls his shoulder, the way a man does with an old injury he no longer bothers about. \"So we'll do it properly. You should know that I have had this fight rather a lot, and that losing it has never once inconvenienced me for longer than a night.\""
      }
    ]
  },
  {
    "id": "anti_player_encounter_final",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_encounter_final_1",
        "text": "He is sitting on the temple steps with his sword across his knees and his hands resting on it, and he does not get up when you come into the courtyard."
      },
      {
        "id": "anti_player_encounter_final_2",
        "text": "\"I've stopped ambushing you,\" he says. \"You've beaten every method I have and I am not interested in inventing new ones to lose with. So I'm here, and I'll be here tomorrow, and the day after.\" He nods at the ruin behind him. \"You know what's under this floor. That's why you came. Either draw, or say whatever it is you came to say — but be aware that a great many desperate people have said comforting things to me over the years, and I have got very good at not being comforted.\"",
        "grantsKnowledge": ["anti_player_awaits_at_temple"]
      }
    ]
  },
  {
    "id": "anti_player_temple_records",
    "speaker": "The Records Beneath the Temple",
    "lines": [
      {
        "id": "anti_player_temple_records_1",
        "text": "The lower vault has not been swept in an age and the shelving is arranged by a scheme nobody now alive was taught. It takes most of a day to find the register, and the register is not what you were looking for, and it is better."
      },
      {
        "id": "anti_player_temple_records_2",
        "text": "A list of the chosen. Not one name — a column of them, going back further than the kingdom, each with a date of choosing and a blank space beside it where a date of death should be. Four names down from the bottom, in a hand that has faded to the colour of weak tea: Aldric Vane, of Dawnmere. Chosen. No date beside it. The three names after his are blank in a different way — never filled in at all."
      },
      {
        "id": "anti_player_temple_records_3",
        "text": "And beneath the register, in the same vault, an account of a working done four centuries ago by people with no chosen one anywhere near them — a great construction laid down across a season, and the same wake behind it: the same days repeating, the same handful of witnesses carrying their memories through it while the world was put back around them. It ended when the working ended. It had nothing to do with anybody being alive or dead.",
        "grantsKnowledge": ["anti_player_identity_known", "temple_records_prove_ritual_anchors_loop"]
      }
    ]
  },
  {
    "id": "anti_player_motivation_revealed",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_motivation_revealed_1",
        "text": "He is beaten and he is not going anywhere, and he seems entirely unbothered by either fact. He sits down against the wall with the deliberateness of a man who has done this before and knows roughly how long it takes."
      },
      {
        "id": "anti_player_motivation_revealed_2",
        "text": "\"Ask, then. You've earned a straight answer and I have about a quarter of an hour.\" He tips his head back. \"Ninety-four years. I counted for the first sixty and then I stopped, which I'd recommend. I got as far as the citadel eleven times. Twice I got inside it.\""
      },
      {
        "id": "anti_player_motivation_revealed_3",
        "text": "\"And here is what I worked out, and I want you to actually engage with it rather than deciding I'm mad, because I'm not. The loop is anchored to the chosen. Always has been. I tested it the only way it can be tested — I stopped, entirely, for one full run. Did nothing. Went nowhere. And the world still came back to that morning, which told me the anchor wasn't my *effort*.\" A shrug. \"So it's my continued existence. Or now, yours. One of us has to be permanently out of it before the world is allowed to move forward, and I have spent thirty years failing to get myself permanently out of it. That leaves you. I'm sorry. I'd genuinely rather it were me.\"",
        "grantsKnowledge": ["anti_player_motivation_known"]
      }
    ]
  },
  {
    "id": "anti_player_severance",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_severance_1",
        "text": "You put the register down on the step beside him — the column of names, the blank spaces, the account of the working four centuries back. He does not pick it up straight away. He looks at it for a long moment the way a man looks at a physician's face."
      },
      {
        "id": "anti_player_severance_2",
        "text": "\"Three names after mine,\" he says eventually. \"Never filled in.\" And then, much later: \"No chosen one anywhere near it. Four hundred years ago. And it still—\" He stops. He reads it again, and then a third time, and his hand is not entirely steady on the page. \"It ended when the working ended.\""
      },
      {
        "id": "anti_player_severance_3",
        "text": "\"I tested the wrong thing.\" He says it quite calmly. \"I tested whether it was my effort. It never occurred to me to test whether it was a person at all, because by the time I thought to ask, I had already — \" He stops again. He is silent long enough that the light moves on the courtyard stones."
      },
      {
        "id": "anti_player_severance_4",
        "text": "\"Then I have spent thirty years hunting the wrong quarry, and everything I did to you I did for a reason that was not true.\" He hands the register back and does not look at you while he does it. \"I won't ask you to say it's all right. It isn't, and you'd be lying, and I've had enough of being lied to comfortably.\"",
        "grantsKnowledge": ["anti_player_accepted_the_proof"]
      },
      {
        "id": "anti_player_severance_5",
        "text": "He stands, and folds his coat over his arm, and for the first time since you have known him he looks his actual age. \"I'll not be in your way again. Not this loop, not any of them — you have my word, for whatever ninety-four years of being wrong has left that worth.\" At the courtyard arch he pauses. \"The citadel. Go in from the north cistern, not the gate. I lost four runs learning that. It's yours now.\"",
        "grantsKnowledge": ["anti_player_neutralized", "ebon_citadel_north_cistern_route"]
      }
    ]
  },
  {
    "id": "anti_player_assassination_battle_victory",
    "speaker": "Dawnmere",
    "lines": [
      {
        "id": "anti_player_assassination_battle_victory_1",
        "text": "The hired men are down or running. The grey-haired man is not at the well any more, and nobody in the lane can tell you when he left or which way he went — several of them are not sure there was a man at the well at all."
      },
      {
        "id": "anti_player_assassination_battle_victory_2",
        "text": "One thing stays with you, past the shaking and the noise and the business of the afternoon. He knew about the cooperage door. It was barred on the inside. You checked."
      }
    ]
  },
  {
    "id": "anti_player_duel_battle_victory",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_duel_battle_victory_1",
        "text": "He goes down on one knee in the road and stays there, breathing hard, and makes no attempt whatsoever to get up or to reach the sword he has dropped."
      },
      {
        "id": "anti_player_duel_battle_victory_2",
        "text": "\"Well,\" he says. \"That's new.\" He almost laughs and it costs him. \"Finish it if you're going to. You'll want to be quick — it's a long walk back to Dawnmere and I'd rather not do the last part of it in company.\""
      }
    ]
  },
  {
    "id": "anti_player_ambush_battle_victory",
    "speaker": "The Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_ambush_battle_victory_1",
        "text": "The ditch is quiet again. Whoever is left in it is not getting up, and the grey man is thirty yards off down the verge, walking — not running, walking — with the unhurried gait of somebody who has already stopped thinking about this road."
      },
      {
        "id": "anti_player_ambush_battle_victory_2",
        "text": "\"That was the last of the easy ones,\" he calls back, without turning. \"Steel on you directly. Twice now. I'll stop wasting it.\" He is quiet for a few paces. \"The trouble with you is that you keep what you learn and everyone else keeps nothing. I have been solving the wrong half of that.\""
      }
    ]
  },
  {
    "id": "anti_player_training_strike_battle_victory",
    "speaker": "The Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_training_strike_battle_victory_1",
        "text": "The swordmaster is alive. Shaken, bleeding from the forearm, entirely uncomprehending about why any of this happened in his yard — but alive, and that turns out to matter more to you than the fighting did."
      },
      {
        "id": "anti_player_training_strike_battle_victory_2",
        "text": "The grey man is already at the gallery stair. \"Noted,\" he says. \"You'll defend the furniture. I did wonder.\" He pauses with one hand on the rail. \"Then it isn't the teaching that makes you dangerous, is it. Anyone can be taught. It's that people will stand in a yard and bleed for you on four days' acquaintance.\" Something in his face closes. \"That's a narrower thing to break. Narrower is easier.\""
      }
    ]
  },
  {
    "id": "anti_player_court_battle_victory",
    "speaker": "The Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_court_battle_victory_1",
        "text": "The Chamberlain is under the desk, unhurt and furious about it, and the inner door is still shut. Somewhere below, someone has finally thought to raise the alarm."
      },
      {
        "id": "anti_player_court_battle_victory_2",
        "text": "\"Eleven years to be certain of that door,\" the grey man says, backing toward the servants' passage with his blade still up, \"and you kept it in an afternoon.\" He does not sound angry. He sounds like a man crossing a line off a list. \"Doors can be replaced. That was my error — I went after the hinge instead of the house.\" He steps into the dark of the passage. \"You don't need a door if the room already thinks you're a liar.\""
      }
    ]
  },
  {
    "id": "anti_player_sabotage_battle_victory",
    "speaker": "The Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_sabotage_battle_victory_1",
        "text": "You get to the table before the letters do. Forty sheets in your own hand, and every one of them still here, unsent, to be laid in front of the people they were written to damn — which is the only thing that could have disproved them."
      },
      {
        "id": "anti_player_sabotage_battle_victory_2",
        "text": "The grey man watches you gather them without any attempt to stop you. \"Paper,\" he says, with real disgust, and it is not clear whether he means the letters or himself. \"A forgery only works until somebody holds it up next to the man. I have been trying to make them doubt your word.\" He lifts the lamp and looks at you properly. \"I should have been making them doubt your orders. Those they obey without checking.\""
      }
    ]
  },
  {
    "id": "anti_player_infiltration_battle_victory",
    "speaker": "The Grey-Haired Stranger",
    "lines": [
      {
        "id": "anti_player_infiltration_battle_victory_1",
        "text": "It ends when the sergeant lowers his spear, looks at you, looks at the seal in his hand, and says, very quietly, that he would like to hear the order again from someone whose face he knows. After that the line simply comes apart. Most of them never struck a blow."
      },
      {
        "id": "anti_player_infiltration_battle_victory_2",
        "text": "The grey man does not run. He stands in the ruin of his own arrangement and watches your soldiers decide, one by one, that they are yours. \"Ah,\" he says at last. \"There it is.\" He sheathes the sword. \"I've spent a century using other men's hands because mine were never enough. Every one of them has failed me and every one of them has failed for the same reason — at the last moment they would rather be yours than mine.\" He turns to go. \"So. No more hands. Next time it's me, and you can find out whether that changes anything.\""
      }
    ]
  },
  {
    "id": "anti_player_final_battle_victory",
    "speaker": "Aldric Vane",
    "lines": [
      {
        "id": "anti_player_final_battle_victory_1",
        "text": "It does not take long. He is not a young man and he has not been a young man for a very great while, and at the end he goes down on the temple steps where he was sitting, and the sword goes down with him, and the courtyard is extremely quiet."
      },
      {
        "id": "anti_player_final_battle_victory_2",
        "text": "\"There,\" he says, when he can. \"Now you know.\" He is looking past you at the ruin, not at you. \"I'll be in Dawnmere in the morning. Same as you. Same as always. Whatever you thought this was going to settle — it doesn't, and it never has, and I have been on this side of it a great deal longer than you have.\""
      },
      {
        "id": "anti_player_final_battle_victory_3",
        "text": "You stand in the courtyard afterwards with a won fight behind you and nothing whatsoever gained by it. He was right about the walk back. He is right about the morning. Killing him is the one method you have both already tried."
      }
    ]
  }
]
